import {routeTo} from '@/utils/router'

export const getBlogContent = () => ({
  metaTitle: 'blog.meta-title',
  metaDescription: 'blog.meta-desc',
  articleListTitle: 'blog.article-list-title',
  header: {
    buttonLinkText: 'button-start-with-registration',
    buttonLinkHref: routeTo.verification.form(),
  },
  hero: {
    title: 'blog.hero-title',
    subtitle: 'blog.hero-subtitle',
  },
  metrics: {
    title: 'blog.metrics-title',
    description: 'blog.metrics-desc',
    importanceTitle: 'blog.metrics-key-0',
    willingnessTitle: 'blog.metrics-key-1',
  },
  industries: {
    heroTitle: 'blog.industry-hero-title',
    heroSubtitle: 'blog.industry-hero-subtitle',
    title: 'blog.industry-list-title',
    buttonShowMore: 'show-more-text',
    buttonShowLess: 'show-less-text',
    cardTitle: 'blog.industry-name',
  },
  topics: {
    metaTitle: 'blog.topic-meta-title',
    metaDescription: 'blog.topic-meta-desc',
    heroTitle: 'blog.topic-hero-title',
    heroSubtitle: 'blog.topic-hero-subtitle',
  },
  academyBanner: {
    title: 'blog.academy-banner-title',
    buttonLinkHref: routeTo.tmAcademy.home(),
    buttonLinkText: 'blog.academy-banner-button',
  },
  getStarted: {
    title: 'verification-banner-text',
    buttonLinkHref: routeTo.verification.form(),
    buttonLinkText: 'button-get-started',
  },
  blogByTitle: 'blog-by-text',
  navigationTitle: 'blog.industry-detail-navigation-title',
  navigationButtonText: 'learn-more-text',
})
